import script from "./CommissionContractView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionContractView.vue?vue&type=script&setup=true&lang=js"

import "./CommissionContractView.vue?vue&type=style&index=0&id=0e899ea4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e899ea4"]])

export default __exports__